import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography } from 'material-ui';
import { Field, Form } from 'redux-form';
import { Checkbox, required, formatCurrency } from 'entoro-shared';
import moment from 'moment';

const styles = {
  headerHR: {
    borderBottom: '1px solid #4d5e75',
  },
  title: {
    fontSize: '16px',
    margin: 0,
  },
  labelCell: {
    fontWeight: 700,
    border: 'none',
    width: '200px',
    fontSize: '14px',
  },
  cell: {
    border: 'none',
    fontSize: '14px',
  },
  subheading: {
    color: '#8c8c8c',
    fontWeight: '300',
  },
};

const InvestmentReview = ({
  offer,
  initialValues,
  handleSubmit,
  paymentDetails,
  classes,
}) => {
  const { investmentAmount } = initialValues;
  return (
    <Form onSubmit={handleSubmit}>
      <div className='step' style={{ float: 'left', maxWidth: '100%' }}>
        <Typography align='center' className={classes.title}>
          Please acknowledge that you have read and agree to the following
          statements by checking all the boxes below:  
        </Typography>
        <Field
          component={Checkbox}
          validate={required}
          required
          name='investmentReviewAgreement'
          label={`I am investing ${formatCurrency(investmentAmount)} in ${
            offer.issuerCompany.name
          }, at ${formatCurrency(
            paymentDetails.pricePerShareOrToken
          )} per share`}
        />

        <Field
          component={Checkbox}
          validate={required}
          required
          name='closingDateAgreement'
          label={` I may cancel my commitment by ${moment
            .utc(new Date(offer.closingDate))
            .subtract(2, 'days')
            .format('DD/MM/YYYY')}`}
        />
      </div>
    </Form>
  );
};

InvestmentReview.propTypes = {
  classes: PropTypes.object.isRequired,
  offer: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  selectedPaymentType: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default withStyles(styles)(InvestmentReview);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/PaymentProcess/PaymentProcessForm/InvestmentReview.js